/**
 * Product Show Page Component
 * Handles product image zoom functionality and retailer link tracking
 * Pure Vanilla JavaScript - no jQuery required
 */
;(function () {
	'use strict'

	/**
	 * Initialize product show functionality when DOM is ready
	 */
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init)
	} else {
		init()
	}

	function init() {
		initRetailerTracking()
		initImageZoom()
	}

	/**
	 * Initialize tracking for retailer link clicks
	 */
	function initRetailerTracking() {
		document.querySelectorAll('.retailer-link').forEach(link => {
			link.addEventListener('click', function (event) {
				// Push data to Google Analytics data layer
				if (typeof dataLayer !== 'undefined') {
					dataLayer.push({
						topCategory: this.getAttribute('data-category'),
						uvp: this.getAttribute('data-price'),
					})
				}
			})
		})
	}

	/**
	 * Initialize Drift.js image zoom functionality for product images
	 */
	function initImageZoom() {
		// Check if Drift library is available
		if (typeof Drift === 'undefined') {
			console.warn('Drift.js library not found. Image zoom functionality will not work.')
			return
		}

		const swiperContainer = document.querySelector('.swiper-container')
		if (!swiperContainer) {
			return
		}

		document.querySelectorAll('.product-image').forEach(element => {
			new Drift(element, {
				inlinePane: false,
				paneContainer: swiperContainer,
				containInline: true,
				zoomFactor: 2,
			})
		})

		// Listen to existing gallery__toggle button
		const toggleButton = document.querySelector('.gallery__toggle')
		if (toggleButton) {
			let isZoomOpen = false

			toggleButton.addEventListener('click', function () {
				if (!isZoomOpen) {
					// Opening zoom - set min-height
					const viewportHeight = window.innerHeight
					const minHeight = viewportHeight - 175
					swiperContainer.style.minHeight = minHeight + 'px'
					isZoomOpen = true
				} else {
					// Closing zoom - reset min-height
					swiperContainer.style.minHeight = ''
					isZoomOpen = false
				}
			})
		}
	}
})()
